import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_AREAS } from '../data/serviceAreas';

// "Also serving" line (town links) for the bottom of key service pages + home.
export const AlsoServing = () => {
  const towns = SERVICE_AREAS; // airdrie, cochrane, okotoks, chestermere, strathmore, high-river, rocky-view-county

  return (
    <p className="text-center text-gray-600 py-8 px-4 max-w-4xl mx-auto" data-testid="also-serving">
      Also serving{' '}
      {towns.map((t, i) => {
        const label = t.slug === 'rocky-view-county' ? 'Rocky View County acreages' : t.name;
        const sep = i === towns.length - 1 ? '' : i === towns.length - 2 ? ' and ' : ', ';
        return (
          <React.Fragment key={t.slug}>
            <Link to={`/service-areas/${t.slug}`} className="text-[#1E3A5F] font-medium hover:underline">
              {label}
            </Link>
            {sep}
          </React.Fragment>
        );
      })}
      .
    </p>
  );
};

export default AlsoServing;
